import { gql } from '@apollo/client';

const SEARCH_TAGS = gql`
  query SEARCH_TAGS($projectId: String!) {
    tag {
      searchTags(projectId: $projectId, text:"") {
        id
        name
        sort
      }
    }
  }
`;

export { SEARCH_TAGS };
